import {
  MergeConditionsConflict,
  type FailingRulesAndConditionPayload,
  type MergeConditionType,
  type RuleRollupPayload,
} from '@github-ui/mergebox/types'

// These blockers already have dedicated For You items.
const RULE_ROLLUP_TYPES_HANDLED_BY_FOR_YOU_ITEMS = [
  'REQUIRED_REVIEW_THREAD_RESOLUTION',
  'REQUIRED_WORKFLOW_STATUS_CHECKS',
]

// PULL_REQUEST rollups are hidden only when every reported reason has a dedicated item.
// Mergebox payloads may use either lowercase strings or uppercase enum values.
const PULL_REQUEST_FAILURE_REASONS_HANDLED_BY_FOR_YOU_ITEMS = ['changes_requested', 'thread_resolution_required']

type MergeCondition = FailingRulesAndConditionPayload & {type: string}

function isRuleRollup(item: FailingRulesAndConditionPayload): item is RuleRollupPayload {
  return 'ruleType' in item
}

function isMergeCondition(item: FailingRulesAndConditionPayload): item is MergeCondition {
  return 'type' in item
}

function isRuleHandledByForYouItem(rule: RuleRollupPayload): boolean {
  if (RULE_ROLLUP_TYPES_HANDLED_BY_FOR_YOU_ITEMS.includes(rule.ruleType)) {
    return true
  }

  if (rule.ruleType !== 'PULL_REQUEST' || !rule.metadata || !('failureReasons' in rule.metadata)) {
    return false
  }

  const {failureReasons} = rule.metadata
  return (
    failureReasons.length > 0 &&
    failureReasons.every(reason => PULL_REQUEST_FAILURE_REASONS_HANDLED_BY_FOR_YOU_ITEMS.includes(reason.toLowerCase()))
  )
}

// Keep the catch-all item for blockers not represented by another For You item.
export function hasUnhandledMergeBlocker(failingItems: FailingRulesAndConditionPayload[]): boolean {
  return failingItems.some(item => {
    if (isRuleRollup(item)) return !isRuleHandledByForYouItem(item)
    if (isMergeCondition(item)) return !MergeConditionsConflict.includes(item.type as MergeConditionType)
    return true
  })
}
